<template>
    <div v-if="pmp_case_details">
        <modal :show.sync="show_modal" :hide-footer="true" size="xl">
            <div v-if="pmp_case_details.additional_info.additional_rebate_approval.approval_check === 'available'">
                <h3 class="mb-3">Please state your reason for requesting additional {{pmp_case_details.settings.cb_add_percent_to_customer}}% rebate:</h3>
                <div class="mb-3">
                    <b-textarea
                    rows="5"
                    v-model="reason"
                    ></b-textarea>
                    <small>Request will be sent for approval.</small>
                </div>
                <div class="d-flex justify-content-between">
                    <el-button class="bg-dark text-white" @click="show_modal = false">Cancel</el-button>
                    <el-button class="bg-success text-white" @click="confirm" :loading="is_loading">Confirm</el-button>
                </div>
            </div>
            <div v-else>
                <h3 class="mb-0">Status: 
                    <span class="text-warning" v-if="pmp_case_details.additional_info.additional_rebate_approval.approval_check === null">Pending</span>
                    <span class="text-success" v-if="pmp_case_details.additional_info.additional_rebate_approval.approval_check == 1">Approved</span>
                    <span class="text-danger" v-if="pmp_case_details.additional_info.additional_rebate_approval.approval_check == 0">Rejected</span>
                </h3>
                <small>Request sent on: {{ pmp_case_details.additional_info.additional_rebate_approval.created_at | dateFormatString }} </small>
                <div v-if="pmp_case_details.additional_info.additional_rebate_approval.requester_remark" class="mt-3">
                    <p class="badge bg-dark text-white">Requester Remark</p>
                    <small class="d-block mt-1">{{ pmp_case_details.additional_info.additional_rebate_approval.requester_remark || 'N/A' }} </small>
                </div>
                <div v-if="pmp_case_details.additional_info.additional_rebate_approval.reviewer_remark" class="mt-2">
                    <p class="badge bg-dark text-white">Reviewer Remark: </p>
                    <small class="d-block mt-1">{{ pmp_case_details.additional_info.additional_rebate_approval.reviewer_remark || 'N/A' }}</small> 
                </div>
                <div v-if="pmp_case_details.additional_info.additional_rebate_approval.approver_remark" class="mt-2">
                    <p class="badge bg-dark text-white">Approver Remark: </p>
                    <small class="d-block mt-1">{{ pmp_case_details.additional_info.additional_rebate_approval.approver_remark || 'N/A' }}</small> 
                </div>
            </div>
        </modal>  
    </div>
</template>
<script>
import { Select, Option, Button } from 'element-ui'
    import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import { useAuthStore } from '@/stores/authStore'
import { mapState, mapActions } from 'pinia'

    export default {
        props:['product', 'pmp_case_details'],
        mixins: [notifyFunctionMixin],
        components: {
            [Option.name]: Option,
            [Select.name]: Select,
            [Button.name]: Button,
        },
        data() {
            return {
                is_loading:false,
                show_modal: false,
                reason: ''
            }
        },
        watch:{
            product(newVal){
                this.change_unitno_id = null
            }
        },
        computed:{
            ...mapState(useAuthStore, ['auth_user'])
        },
        methods: {
            toggleView() {
                this.show_modal = !this.show_modal;
            },
            confirm(){
                if(this.reason === ''){
                    this.errorFunction(null, 'Please add a reason')
                    return
                }

                let data = {
                    prod_id: this.product.prod_id,
                    customer_id: this.product.prod_customer_id,
                    prod_pm_property_src: this.product.product_detail.prod_pm_property_src,
                    reason: this.reason,
                    cb_add_percent_to_customer: this.pmp_case_details.settings.cb_add_percent_to_customer
                }

                this.is_loading = true
                axios.post(services.lookup + 'pmp/cases.im2uv2/'+this.product.prod_id+'/request-additional-rebate', data, {headers: getHeader()})
                    .then(res => {
                        this.show_modal = false
                        this.is_loading = false
                        caseEventBus.$emit('update-pmp-case-detail', res.data)
                        this.notifySuccess('<b>Case</b> - Request Additional Rebate Successful.')
                    })
                    .catch(e =>{
                        this.is_loading = false
                        this.errorFunction(e)
                    })
            }
        },
    }
</script>